import { ArrowRight, Star } from "lucide-react";
import { Link } from "react-router";

import drew from "@/../../hypetrain/static/img/exec-home/drew-impact.png";
import { LazyImg } from "@/components/helpers/ui/LazyImg";
import { Container } from "@/components/pieces/bootstrap";
import { QuoteIcon } from "@/components/pieces/marketing/QuoteIcon";
import {
  StyledSubtitle,
  StyledTitle,
} from "@/components/pieces/marketing/Titles";
import { Button } from "@/components/ui/button";
import { PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";

export function Impact() {
  return (
    <div className="bg-blue-900 py-12 md:py-20">
      <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH}>
        {/* Stats and Testimonial Grid */}
        <div className="flex flex-col overflow-hidden lg:flex-row lg:rounded-3xl lg:bg-white/7">
          <div className="lg:p-16">
            <StyledTitle className="text-white lg:text-left">
              Our Impact
            </StyledTitle>
            <StyledSubtitle className="text-white lg:text-left">
              Drive ROI with Exec
            </StyledSubtitle>
            {/* Stats grid - left side */}
            <div className="mt-12 grid grid-cols-1 gap-8 pb-12 sm:grid-cols-2 lg:col-span-12">
              {/* Stat box 1 */}
              <div className="rounded-lg bg-white/7 p-10 text-center lg:bg-transparent lg:p-0">
                <div className="mb-3 text-4xl font-bold text-white sm:text-6xl">
                  92%
                </div>
                <div className="mb-2 font-medium text-blue-300">
                  Program Completion
                </div>
                <div className="text-gray-400">
                  Industry-leading completion rate across all training programs
                </div>
              </div>

              {/* Stat box 2 */}
              <div className="rounded-lg bg-white/7 p-10 text-center lg:bg-transparent lg:p-0">
                <div className="mb-3 flex items-center justify-center gap-3 text-4xl font-bold text-white sm:text-6xl">
                  +22 <span className="text-xl">Points</span>
                </div>
                <div className="mb-2 font-medium text-blue-300">
                  Quantified Improvement
                </div>
                <div className="text-gray-400">
                  Average improvement on 100-point skill assessment
                </div>
              </div>

              {/* Stat box 3 */}
              <div className="rounded-lg bg-white/7 p-10 text-center lg:bg-transparent lg:p-0">
                <div className="mb-3 text-4xl font-bold text-white sm:text-6xl">
                  98%
                </div>
                <div className="mb-2 font-medium text-blue-300">
                  Participant Satisfaction
                </div>
                <div className="text-gray-400">
                  Participants report their experience directly improved
                  performance
                </div>
              </div>

              {/* Stat box 4 */}
              <div className="rounded-lg bg-white/7 p-10 text-center md:p-0 lg:bg-transparent">
                <div className="flex items-center justify-center">
                  <span className="text-4xl font-bold text-white sm:text-6xl">
                    4.9
                  </span>
                  <Star
                    fill="currentColor"
                    className="ml-2 text-yellow-400"
                    size={32}
                  />
                </div>
                <div className="mb-2 font-medium text-blue-300">
                  Average Session Rating
                </div>
                <div className="text-gray-400">
                  Participants consistently rate their coaching experiences
                  near-perfect
                </div>
              </div>
            </div>
          </div>
          {/* Testimonial - right side */}
          <div className="relative flex items-center overflow-hidden bg-white/8 p-8 lg:p-12">
            <div className="absolute inset-0 z-0 hidden lg:block">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 509 636"
                preserveAspectRatio="xMidYMid slice"
                className="text-blue-950/40"
              >
                <g stroke="currentColor" strokeWidth={5}>
                  <circle cx={500} cy={320} r={129} opacity={0.4} />
                  <circle cx={500} cy={320} r={268.5} opacity={0.4} />
                  <circle cx={500} cy={320} r={400} opacity={0.4} />
                </g>
              </svg>
            </div>
            <div className="relative z-1 flex w-full flex-col gap-6 rounded-lg bg-white p-6 shadow-lg lg:max-w-md">
              <QuoteIcon height={36} width={42} color="#D4E6FC" />
              <div className="text-gray-800">
                We're now able to deliver highly personalized learning
                experiences at scale, all while delivering a tangible return on
                our investment.
              </div>
              <div className="flex items-start">
                <div className="mr-4 h-18 w-18 overflow-hidden rounded-full">
                  <LazyImg src={drew} width="100%" />
                </div>
                <div>
                  <div className="font-medium">Drew Fifeld</div>
                  <div className="text-sm text-gray-600">
                    Head of Global Talent Development at Axonius
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* CTA Box */}
        <div className="mt-12 flex flex-col items-start justify-between gap-12 overflow-hidden rounded-lg bg-white p-8 md:flex-row md:items-center">
          <div>
            <div className="mb-2 text-2xl font-semibold text-gray-800">
              Don't leave critical conversations up to chance
            </div>
            <div className="text-gray-500">
              Whether it's closing a sale or navigating a company-wide change,
              every interaction counts.
            </div>
          </div>

          <Button size="lg" asChild>
            <Link to="/demo">
              Book a Demo
              <ArrowRight className="ml-2 h-4 w-4" />
            </Link>
          </Button>
        </div>
      </Container>
    </div>
  );
}
